class AnchorLinkManager {
  constructor() {
    this.headerHeight = 80;
    this.extraOffset = 30;
    this.init();
  }

  init() {
    document.addEventListener("click", this.handleAnchorClick.bind(this));
    window.addEventListener("resize", this.updateHeaderHeight.bind(this));
    this.handleInitialHash();
    this.updateHeaderHeight();
  }

  updateHeaderHeight() {
    const headerHeightValue = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--header-height");

    this.headerHeight = headerHeightValue
      ? parseInt(headerHeightValue.trim())
      : 80;
  }

  handleAnchorClick(event) {
    const link = event.target.closest(".anchor-link");
    if (!link) return;

    event.preventDefault();

    const href = link.getAttribute("href");
    const hash = href.split("#")[1];

    if (!hash) return;

    this.scrollToElement(hash);
  }

  handleInitialHash() {
    const hash = window.location.hash.substring(1);
    if (hash) {
      setTimeout(() => this.scrollToElement(hash), 100);
    }
  }

  scrollToElement(targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    const targetPosition = this.getElementPosition(targetElement);
    const offset = this.headerHeight + this.extraOffset;

    window.scrollTo({
      top: targetPosition - offset,
      behavior: "smooth",
    });

    history.pushState(null, null, `#${targetId}`);
    targetElement.focus();
  }

  getElementPosition(element) {
    const rect = element.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new AnchorLinkManager());
} else {
  new AnchorLinkManager();
}
